/** Generic redacted placeholder text, written over a whole sensitive value (const/telemetry-redaction.ts and the log paths) */
export const REDACTED_PLACEHOLDER = '[REDACTED]';

/** PII-specific redaction placeholder text per category (used by const/pii-redaction.ts) */
export const REDACTION_PLACEHOLDERS = {
	email: '[EMAIL_REDACTED]',
	phone: '[PHONE_REDACTED]',
	ssn: '[SSN_REDACTED]',
	creditCard: '[CARD_REDACTED]',
	address: '[ADDRESS_REDACTED]',
} as const;
